import React, { useState, useEffect } from "react";
import SaveIcon from "@mui/icons-material/SaveRounded";
import CloseIcon from "@mui/icons-material/CloseRounded";
import { Button, Modal, Col, Row, Spinner } from "react-bootstrap";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import { useForm, Controller } from "react-hook-form";
import _ from "lodash";
import SwalMessage from "../_Components/SwalMessage";
import ApiGallery from "../../../core/api/api.gallery";
import { PatternFormat } from "react-number-format";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import SelectComponent from "../_Components/ReactSelectComponent";
import { orange } from "@mui/material/colors";
import { Box, Typography } from "@mui/material";
import Dropzone from "react-dropzone";

export const AddModal = ({ showModalGallery, setShowModalGallery }) => {
  const handleClose = () => {
    setShowModalGallery(false);
  };
  const [listOption, setListOption] = useState([]);
  const [listType, setListType] = useState([]);
  const [listSelective, setListSelective] = useState([]);
  const [type, setType] = useState([]);
  const [option, setOption] = useState([]);
  const [btnLoading, setBtnLoading] = useState(false);
  const [showErrorForselecetdBox, setShowErrorForselecetdBox] = useState(false);
  const [selectBoxName, setSelectBoxName] = useState("");

  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
    setValue,
  } = useForm({
    defaultValues: { id: 0, status: true },
  });

  useEffect(() => {
    (async () => {
      try {
        //if (location != null && !_.isEmpty(location.state) && _.isNumber(location.state?.id)) {
        const galleryOptionList = await ApiGallery.getGalleryOption();
        setListOption(galleryOptionList.data);
        setValue("option", galleryOptionList.data.map(gi => ({ label: gi.title, value: gi.value }))[0]);
        setOption(galleryOptionList.data[0].value);
        const galleryTypeList = await ApiGallery.getGalleryType();
        setListType(galleryTypeList.data);
        //}
      } catch (error) {
      }
    })();
    return () => { };
  }, []);

  const handlelistTypeChange = async (value) => {
    setValue("type", value?.value);
    setType(value?.value);
    let listTypeId = value?.value;
    switch (listTypeId) {
      case 1:
        setSelectBoxName("نام تفریح");
        break;
      case 2:
        setSelectBoxName("نوع دستگاه");
        break;
      case 4:
        setSelectBoxName("کلوپ");
        break;
      case 6:
        setSelectBoxName("نام مجتمع");
        break;
      default:
        setSelectBoxName("");
    }
    if (_.isNumber(value?.value) && value?.value > 0) {
      //لیست ایتم های وابسته به انتخاب نوع فایل
      const apiData = await ApiGallery.getSelectiveListByGalleryType({ Type: value?.value });
      if (apiData.succeeded) {
        setListSelective(apiData?.data);
        setValue("selectedId", apiData.data[0].value);
      } else {
        //SwalMessage({ title: apiData.message, iSsuccess: false });
        setListSelective([]);
        setValue("selectedId", undefined);
      }
    } else {
      setListSelective([]);
      setValue("selectedId", undefined);
    }
  };

  const onSubmit = async (data, event) => {
    try {
      setBtnLoading(true);
      //   // ذخیره در دیتا بیس  گالری
      // data.selectedId = listSelective?.length > 0 ? data?.selectedId.value : undefined
      data.selectedId = data?.selectedId?.value;
      data.option = +(data?.option?.value);
      data.type = +(data?.type?.value);

      if (data.option == 1) {
        delete data.length
        delete data.duration
      }

      setShowErrorForselecetdBox(false);
      if ((data.type === 1 || data.type === 2 || data.type === 4 || data.type === 6) && data.selectedId === undefined) {
        setShowErrorForselecetdBox(true);
        return;
      }

      const fileExtentions = [];
      for (let i = 0; i < data.file.length; i++) {
        fileExtentions.push("." + data.file[i].name.split(".").pop());
        //data.fileExtention = "." + data.file[0].name.split('.').pop();
      }
      data.fileExtention = fileExtentions;
      let response1 = await ApiGallery.createGallery(data);
      // props.callBackForRefresh(1);  // برای رفرش عکس های موجود در صفحه والد بدون نیاز به رفرش صفحه
      if (response1.succeeded == false) {
        SwalMessage({ title: response1.message, iSsuccess: response1.error });
        setBtnLoading(false);
      } else {
        // ذخیره فایل
        const formData = new FormData();
        Object.values(data.file).forEach((file, index) => {
          formData.append("my file", data.file[index], data.file[index].name);
          formData.append("key", response1.data.key[index]);
        });

        fetch(
          process.env.REACT_APP_PHOTOPATH_WEB + "/api/v1/Gallery/SaveFile",
          {
            method: "POST",
            body: formData,
          },
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          },
        )
          .then((res) => res.json())
          .then(
            (result) => {
              if (result.substring(0, 1) == 1) {
                setShowModalGallery(false);
                // refresh page
                document.getElementById('submitButton').click();
                SwalMessage({ title: result.substring(2), iSsuccess: true });
              }
              else SwalMessage({ title: result.substring(2), iSsuccess: false });
            },
            (error) => {
            },
          );
      }
    } catch (error) {
      setBtnLoading(false);
    } finally {
      setBtnLoading(false);
    }
  };

  return (
    <div>
      {/* Start Modal */}
      <Modal centered size="md" onHide={handleClose} show={showModalGallery}>
        <form id="form" onSubmit={handleSubmit(onSubmit)}>
          <Modal.Header closeButton>
            <Modal.Title> افزودن تصویر</Modal.Title>
          </Modal.Header>
          <Modal.Body style={{ height: 530 }}>
            <Col xs="12">
              <Row>
                <Col xs="12">
                  <Controller
                    name="file"
                    control={control}
                    defaultValue={[]}
                    render={({ field }) => (
                      <Dropzone onDrop={(acceptedFiles) => {
                        field.onChange(acceptedFiles)
                      }}
                        useFsAccessApi={false} >
                        {({ getRootProps, getInputProps }) => (
                          <Box
                            {...getRootProps()}
                            sx={{
                              border: "2px dashed gray",
                              p: 2,
                              textAlign: "center",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              gap: 2,
                              height: 66,
                              "&:hover": {
                                backgroundColor: "rgba(0,0,0,0.025)",
                                cursor: "pointer",
                                transition: "background-color 300ms"
                              }
                            }}
                          >
                            <input {...getInputProps()} />
                            <Typography>{field.value && field.value.length > 0 ? field.value[0].name : "انتخاب فایل"}</Typography>
                            {field.value && field.value.length > 0 && <Button
                              onClick={(e) => {
                                e.stopPropagation()
                                field.onChange(null)
                              }}
                              sx={{
                                scale: "0.8 !important",
                                zIndex: "10 !important"
                              }}
                              variant="outlined"
                              color="warning"
                            >
                              <i className="far fa-trash-alt" style={{ color: orange[700], fill: orange[700], stroke: orange[700] }} />
                            </Button>
                            }
                          </Box>
                        )}
                      </Dropzone>
                    )}
                  />
                  {/* <input type="file" {...register("file")} multiple required /> */}
                </Col>

                <Col xs="12">
                  <Controller
                    name="type"
                    control={control}
                    rules={{ required: true }}
                    render={({ field }) => (
                      <SelectComponent
                        className="w-100 mt-5"
                        placeholder="ذخیره در پوشه"
                        variant="outlined"
                        size="small"
                        options={listType?.map((item) => ({
                          value: item.id,
                          label: item.title,
                        }))}
                        field={field}
                        onChange={(value) => {
                          handlelistTypeChange(value)
                          field.onChange(value)
                        }}
                      />
                    )}
                  />
                  {errors.type && <span className="text-danger text-small">لطفا ذخیره در پوشه را وارد نمایید</span>}
                </Col>
                <Col xs="12" hidden={listSelective?.length > 0 ? false : true}>
                  <Controller
                    name="selectedId"
                    control={control}
                    render={({ field }) => (
                      <SelectComponent
                        className="w-100 mt-5"
                        placeholder={selectBoxName}
                        options={listSelective?.map((item) => ({
                          value: item.id,
                          label: item.title,
                        }))}
                        field={field}
                      />
                    )}
                  />
                  {showErrorForselecetdBox ? (
                    <span className="text-danger text-small">
                      لطفا <span>{selectBoxName}</span> را وارد نمایید
                    </span>
                  ) : (
                    ""
                  )}
                </Col>

                <Col xs="12">
                  <Controller
                    name="option"
                    control={control}
                    rules={{ required: true }}
                    render={({ field: { value } }) => (
                      <SelectComponent
                        className="w-100 mt-5"
                        placeholder="نوع فایل"
                        variant="outlined"
                        size="small"
                        options={listOption?.map((item) => ({
                          value: item.id,
                          label: item.title,
                        }))}
                        value={value}
                        onChange={(value) => {
                          setOption(value?.value);
                          setValue("option", value);
                        }}
                        noClear
                      />
                    )}
                  />
                  {errors.option && <span className="text-danger text-small">لطفا نوع فایل را وارد نمایید</span>}
                </Col>

                <Col xs="12">
                  <Controller
                    name="imageAlt"
                    control={control}
                    rules={{ required: true }}
                    render={({ field: { onChange, value } }) => (
                      <TextField
                        label="عنوان"
                        margin="normal"
                        variant="outlined"
                        size="small"
                        value={value || ""}
                        onInput={onChange}
                      />
                    )}
                  />
                  {errors.imageAlt && <span className="text-danger text-small">لطفا عنوان را وارد نمایید</span>}
                </Col>
                {/* <Col xs="12">
                  <Controller
                    name="label"
                    control={control}
                    render={({ field: { onChange, value } }) => (
                      <TextField
                        label="برچسب"
                        margin="normal"
                        variant="outlined"
                        size="small"
                        value={value || ""}
                        onChange={onChange}
                      />
                    )}
                  />
                </Col> */}
                <Col xs="12">
                  <Controller
                    name="duration"
                    rules={{
                      required: option != undefined && option != 1
                    }}
                    control={control}
                    render={({ field: { onChange, value } }) => (
                      <PatternFormat
                        customInput={TextField}
                        label="مدت زمان"
                        type="search"
                        onKeyDown={(e) => {
                          if (e.key === "Escape") {
                            e.stopPropagation()
                          }
                        }}
                        size="small"
                        margin="normal"
                        value={value || ""}
                        variant="outlined"
                        className={`${option != undefined && option != 1 ? "" : "opacity-50"}`}
                        onChange={onChange}
                        disabled={option != undefined && option != 1 ? false : true}
                        placeholder="00:00:00"
                        format="##:##:##"
                        allowEmptyFormatting={false}
                      />
                    )}
                  />
                </Col>

                <Col xs="12">
                  <Controller
                    name="length"
                    control={control}
                    rules={{
                      required: option != undefined && option != 1
                    }}
                    render={({ field: { onChange, value } }) => (
                      <TextField
                        label="حجم فایل"
                        margin="normal"
                        variant="outlined"
                        size="small"
                        className={`${option != undefined && option != 1 ? "" : "opacity-50"}`}
                        disabled={option != undefined && option != 1 ? false : true}
                        value={value || ""}
                        onInput={onChange}
                      />
                    )}
                  />
                </Col>

                <Col xs="12">
                  <Controller
                    name="description"
                    control={control}
                    render={({ field: { onChange, value } }) => (
                      <TextField
                        label="توضیحات"
                        margin="normal"
                        variant="outlined"
                        size="small"
                        value={value || ""}
                        onInput={onChange}
                      />
                    )}
                  />
                </Col>

                <Col xs="12">
                  <FormControlLabel
                    control={
                      <Controller
                        control={control}
                        name={"status"}
                        render={({
                          field: { onChange, onBlur, value, name, ref },
                          fieldState: { invalid, isTouched, isDirty, error },
                        }) => (
                          <Checkbox
                            color="primary"
                            onBlur={onBlur}
                            onChange={onChange}
                            checked={value}
                            inputRef={ref}
                          />
                        )}
                      />
                    }
                    label="فعال"
                  />
                </Col>
              </Row>
            </Col>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="success" type="submit" disabled={btnLoading}>
              {btnLoading && <Spinner animation="border" variant="warning" size="sm" />}
              <SaveIcon /> ذخیره
            </Button>
            <Button variant="danger" onClick={handleClose}>
              <CloseIcon /> بستن
            </Button>
          </Modal.Footer>
        </form>
      </Modal>
    </div>
  );
};
